import { EyeEmpty, Wallet } from 'iconoir-react';
import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAmount } from '../../../utils';
import Pagination from '../../templates/Pagination';

const OtherTransactionTable = ({ transactions }) => {
  const navigator = useNavigate();
  const rowsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(transactions.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <div className='card p-0 overflow-hidden'>
      <table className="table-modern">
        <thead>
          <tr>
            <th>User</th>
            <th>Trip</th>
            <th>Status</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {transactions && transactions.length > 0 ?
            transactions.slice(startIndex, endIndex).map((transaction, index) => (
              <tr key={transaction.id || index}>
                {transaction.user ? (
                  <td>
                    <div className="flex items-center gap-3">
                      <img
                        className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                        src={transaction.user.profile_pic}
                        alt=""
                        loading="lazy"
                      />
                      <div>
                        <p className="font-semibold text-surface-800">
                          {transaction.user.surname} {transaction.user.other_names}
                        </p>
                        <p className="text-xs text-surface-400 capitalize">
                          {transaction.user.role}
                        </p>
                      </div>
                    </div>
                  </td>
                ) : (
                  <td>
                    <span className='text-surface-400 italic'>N/A</span>
                  </td>
                )}
                <td>
                  {transaction.trip ? (
                    <div className='space-y-1 max-w-[200px]'>
                      <p className='text-xs truncate'>
                        <span className='text-surface-400'>From:</span>{' '}
                        <span className='text-surface-600'>{transaction.trip.origin_description}</span>
                      </p>
                      <p className='text-xs truncate'>
                        <span className='text-surface-400'>To:</span>{' '}
                        <span className='text-surface-600'>{transaction.trip.destination_description}</span>
                      </p>
                    </div>
                  ) : (
                    <span className='text-surface-400 italic'>N/A</span>
                  )}
                </td>
                <td>
                  <span className='badge bg-slate-500 text-white'>
                    {transaction.status?.toLowerCase()}
                  </span>
                </td>
                <td>
                  <span className='font-semibold text-surface-800'>
                    GH₵ {getAmount(transaction).toFixed(2)}
                  </span>
                </td>
                <td className='text-surface-500'>
                  {moment(transaction.createdAt).format('MMM D, YYYY h:mm A')}
                </td>
                <td>
                  <button
                    onClick={() => navigator(`/transactions/${transaction.id}`)}
                    className='btn-ghost p-2 rounded-lg'
                    title='View Details'
                  >
                    <EyeEmpty strokeWidth={2} className='w-4 h-4' />
                  </button>
                </td>
              </tr>
            )) :
            <tr>
              <td colSpan={6} className="text-center py-12">
                <div className='flex flex-col items-center gap-3'>
                  <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                    <Wallet strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                  </div>
                  <div>
                    <p className='font-medium text-surface-600'>No transactions</p>
                    <p className='text-sm text-surface-400'>No transaction data available</p>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className='border-t border-surface-100 px-6 py-4'>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      )}
    </div>
  )
}

export default OtherTransactionTable
